module.exports = __webpack_public_path__ + "static/salon-de-pasajeros---paqueteras-bcf76652c94be2c786be337a4eacdb79.jpg";